import { useQuery } from "@tanstack/react-query";

import useSalesyApiClient from "@/hooks/useSalesyApiClient";

export const useSubscriptionStatus = (enabled: boolean, uid = "default") => {
  const { apiClient } = useSalesyApiClient();

  return useQuery({
    queryKey: ["subscriptionStatus", uid],
    queryFn: () => apiClient.payments.subscriptionStatus(),
    enabled: enabled,
  });
};
